<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Company name -->
    <company-name-field
      v-model="$attrs.company.name"
      :error="$attrs.errors.company.name"
    />

    <!-- Bill template -->
    <bill-template-field
      v-model="$attrs.company.bill_template"
      :error="$attrs.errors.company.bill_template"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import companyNameField from '@/components/forms/company/fields/CompanyName'
import billTemplateField from '@/components/forms/company/fields/BillTemplate'

export default {
  name: 'company-form-blank',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    }
  },
  components: {
    companyNameField,
    billTemplateField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompanyFormBlank.vue?3627b6a7